import React, { Fragment } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from 'react-redux';

import { HasPermission } from '../../../../core/security';

import MediaView from "./views/media";
import ClipView from "./views/clip";

import './videoDetail.scss'

export const VideoDetailView = () => {

    const user = useSelector(state => state.securityRedux.user);

    return (
        <>
            <Routes>
                {
                    HasPermission(user, "vidfleetvideo", [217]) &&
                    <>
                        <Route path='media/:id' element={<MediaView />} />
                        <Route path='clip/:id' element={<ClipView />} />
                    </>
                }
                <Route path="*" element={<Navigate to="/app/error" />} />
            </Routes>
        </>
    )
}

export default VideoDetailView;